import React, { useState, useEffect } from 'react';
import { Attributes } from '@leverege/ui-attributes';
import { Checkbox, List, Text, Pane, Content } from '@leverege/ui-elements';
import { TablePagination } from '@leverege/molten/data-viewers';
import { Paginator } from '@leverege/molten/screens';
import P from '@leverege/promise';
import FotaAttrValueOptionsFactory from "../fotaAttrValueOptions/FotaAttrValueOptionsFactory.js";
import FotaAttrValueOptionFactory from "../fotaAttrValueOptions/FotaAttrValueOptionFactory.js";
import S from './FotaItemMultiSelector.css';
function defaultGetListItemContents({
  item,
  selected,
  onSelect,
  editorProps,
  attr
}) {
  return /*#__PURE__*/React.createElement(Pane, {
    layout: "flex:rowM"
  }, /*#__PURE__*/React.createElement(Checkbox, {
    eventData: editorProps.toItemValue(item),
    value: selected,
    onChange: onSelect
  }), /*#__PURE__*/React.createElement(Text, null, Attributes.get('name', attr?.source?.targetType, item, {
    getImagineName: true
  })));
}
function FotaItemMultiSelector(props) {
  const {
    attr,
    onChange,
    data,
    context,
    getListItemContents = defaultGetListItemContents
  } = props;
  const {
    delegate,
    relationship
  } = context;

  // expect this to look like [ { id, ...more option fields... } ]
  const value = attr.get(data);
  const [options, setOptions] = useState({});
  const [selected, setSelected] = useState({});
  const [pagination, setPagination] = useState({
    perPage: 100,
    page: 0
  });
  const [paginator] = useState(new Paginator({
    onPageChange: ({
      perPage,
      page
    }) => {
      setPagination({
        perPage,
        page
      });
    }
  }));
  paginator.setData({
    ...options,
    ...pagination,
    count: options?.total
  });
  useEffect(() => {
    FotaAttrValueOptionsFactory.create(attr?.source?.targetType, {
      attr,
      delegate,
      relationship,
      limit: paginator.perPage,
      offset: paginator.startIndex
    }).then(options => setOptions(options));
  }, [pagination]);
  useEffect(() => {
    let valid = true;
    if (value && (value.length !== selected.length || !value.every(i => selected[i.id]))) {
      P.mapLimit(value, i => {
        if (valid) {
          return FotaAttrValueOptionFactory.create(attr?.source?.targetType, i);
        }
        return null;
      }).then(result => {
        if (valid) {
          setSelected(result.reduce((prev, curr) => ({
            ...prev,
            [curr.id]: curr
          }), {}));
        }
      });
    }
    return () => {
      valid = false;
    };
  }, [value]);
  const onSelect = ({
    value: isSelected,
    data
  }) => {
    let newValue;
    if (isSelected) {
      newValue = [...(value || [])];
      const existingIndex = newValue.findIndex(entry => entry?.id != null && entry?.id === data?.id);
      if (existingIndex > -1) {
        newValue[existingIndex] = data;
      } else {
        newValue.push(data);
      }
    } else {
      newValue = value?.filter(i => i?.id !== data?.id) || [];
    }
    onChange({
      data: {
        attribute: attr
      },
      value: newValue
    });
  };
  return /*#__PURE__*/React.createElement(Content, {
    relative: true
  }, /*#__PURE__*/React.createElement(Content.Area, null, /*#__PURE__*/React.createElement(List, {
    className: S.container
  }, options?.items?.map(i => {
    const valueItem = value?.find(j => i.id != null && j.id === i.id);
    return /*#__PURE__*/React.createElement(List.Item, {
      key: i.id
    }, getListItemContents({
      item: i,
      value,
      valueItem,
      selected: !!valueItem,
      onSelect,
      editorProps: props,
      attr
    }));
  }))), /*#__PURE__*/React.createElement(Content.Footer, null, /*#__PURE__*/React.createElement(TablePagination, {
    paginator: paginator
  })));
}
const type = 'fotaItemMultiSelector';
export { FotaItemMultiSelector };
export default {
  type,
  editor: FotaItemMultiSelector
};